import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-3xl flex-col items-center px-4 py-24 text-center sm:px-6" data-testid="not-found-page">
      <p className="font-serif text-6xl font-bold text-gold">404</p>
      <h1 className="mt-4 font-serif text-2xl font-bold text-cream-text">This page has been eaten</h1>
      <p className="mt-3 text-sm text-cream-muted">
        Sorry — we couldn't find what you were looking for.
      </p>
      <Link
        to="/"
        className="mt-8 rounded-full bg-gold px-7 py-3 text-sm font-bold text-choco transition-colors hover:bg-gold-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-focus"
        data-testid="not-found-home-link"
      >
        Back to Home
      </Link>
    </div>
  );
}
